import React, { PropsWithChildren } from "react";
import Skeleton from "react-loading-skeleton";
import { HorizontalContainer } from "../../styles/container";
import { SECTION_VERTICAL_SPACING } from "../../styles/spacing";
import { H1 } from "../../styles/text";
import { useNavigation } from "react-router-dom";

type PrimaryHeaderProps = {
  width?: number;
};

export const PrimaryHeader = (props: PropsWithChildren<PrimaryHeaderProps>) => {
  const { width, children } = props;
  const navigation = useNavigation();
  const skeletonWidth = width
    ? width
    : children
    ? children.toString().length * 20
    : 250;
  return (
    <>
      <HorizontalContainer>
        {navigation.state === "loading" ? (
          <Skeleton height={28} width={skeletonWidth} />
        ) : (
          <H1>{children}</H1>
        )}
      </HorizontalContainer>
    </>
  );
};
